import { render, staticRenderFns } from "./OrderInfoPopup.vue?vue&type=template&id=bfc8b7b4&scoped=true&"
import script from "./OrderInfoPopup.vue?vue&type=script&lang=js&"
export * from "./OrderInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoPopup.vue?vue&type=style&index=0&id=bfc8b7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc8b7b4",
  null
  
)

export default component.exports